import React, { Fragment } from 'react'

const AnotherExampleCertificate = ({ studentName, courseName, date }) => (
  <Fragment>
    <div id="root">
      <div style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        backgroundColor: 'white',
        lineHeight: 'normal'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'clip',
          mixBlendMode: 'normal'
        }}>
          <div style={{
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            justifyContent: 'flex-end',
            paddingLeft: '121px',
            paddingRight: '121px',
            paddingBottom: '80px',
            paddingTop: '288px'
          }}>
            <div style={{
              fontFamily: 'Montserrat',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              paddingLeft: '59px'
            }}>
              <div style={{
                position: 'absolute',
                left: '-120.76px',
                right: '-120.76px',
                top: '-295.83px',
                zIndex: 1,
                height: '596px'
              }}>
                <svg
                  width="100%"
                  height="100%"
                  preserveAspectRatio="none"
                  viewBox="0 0 842.2 595.5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{overflow: 'visible'}}
                >
                  <g clipPath="url(#clip0_3491_244)">
                    <path d="M0.498291 0.0819092H842.748V595.582H0.498291V0.0819092Z" fill="white"></path>
                    <path d="M0.498291 0.0819092H843.066V595.806H0.498291V0.0819092Z" fill="white"></path>
                    <mask
                      id="mask0_3491_244"
                      maskUnits="userSpaceOnUse"
                      x="25"
                      y="-197"
                      width="866"
                      height="361"
                      style={{maskType: 'luminance'}}
                    >
                      <mask
                        id="mask1_3491_244"
                        maskUnits="userSpaceOnUse"
                        x="25"
                        y="-197"
                        width="866"
                        height="361"
                        style={{maskType: 'luminance'}}
                      >
                        <path
                          d="M64.0744 -196.742L890.106 -5.79808L851.082 163.066L25.0264 -27.8781L64.0744 -196.742Z"
                          fill="white"
                        ></path>
                      </mask>
                      <g mask="url(#mask1_3491_244)">
                        <path
                          d="M140.082 -525.566L966.114 -334.622L775.17 491.41L-50.8616 300.49L140.082 -525.566Z"
                          fill="white"
                        ></path>
                      </g>
                    </mask>
                    <g mask="url(#mask0_3491_244)">
                      <g opacity="0.9">
                        <path
                          d="M140.073 -525.558L966.113 -334.625L775.181 491.415L-50.8594 300.483L140.073 -525.558Z"
                          fill="#ACCE74"
                        ></path>
                      </g>
                    </g>
                    <mask
                      id="mask2_3491_244"
                      maskUnits="userSpaceOnUse"
                      x="-44"
                      y="-194"
                      width="863"
                      height="354"
                      style={{maskType: 'luminance'}}
                    >
                      <mask
                        id="mask3_3491_244"
                        maskUnits="userSpaceOnUse"
                        x="-44"
                        y="-194"
                        width="863"
                        height="354"
                        style={{maskType: 'luminance'}}
                      >
                        <path
                          d="M-43.6858 -9.90213L780.858 -193.838L818.61 -24.6861L-5.95779 159.274L-43.6858 -9.90213Z"
                          fill="white"
                        ></path>
                      </mask>
                      <g mask="url(#mask3_3491_244)">
                        <path
                          d="M-116.79 -337.646L707.754 -521.582L891.69 302.962L67.1462 486.922L-116.79 -337.646Z"
                          fill="white"
                        ></path>
                      </g>
                    </mask>
                    <g mask="url(#mask2_3491_244)">
                      <g opacity="0.8">
                        <path
                          d="M-116.796 -337.64L707.755 -521.581L891.696 302.97L67.145 486.911L-116.796 -337.64Z"
                          fill="#0095DF"
                        ></path>
                      </g>
                    </g>
                    <mask
                      id="mask4_3491_244"
                      maskUnits="userSpaceOnUse"
                      x="-63"
                      y="444"
                      width="883"
                      height="362"
                      style={{maskType: 'luminance'}}
                    >
                      <mask
                        id="mask5_3491_244"
                        maskUnits="userSpaceOnUse"
                        x="-63"
                        y="444"
                        width="883"
                        height="362"
                        style={{maskType: 'luminance'}}
                      >
                        <path
                          d="M780.786 805.81L-62.7898 610.834L-24.2698 444.154L819.306 639.154L780.786 805.81Z"
                          fill="white"
                        ></path>
                      </mask>
                      <g mask="url(#mask5_3491_244)">
                        <path
                          d="M702.57 1144.23L-141.03 949.234L53.9702 105.658L897.546 300.658L702.57 1144.23Z"
                          fill="white"
                        ></path>
                      </g>
                    </mask>
                    <g mask="url(#mask4_3491_244)">
                      <g opacity="0.9">
                        <path
                          d="M702.565 1144.23L-141.019 949.244L53.9685 105.66L897.553 300.648L702.565 1144.23Z"
                          fill="#ACCE74"
                        ></path>
                      </g>
                    </g>
                    <mask
                      id="mask6_3491_244"
                      maskUnits="userSpaceOnUse"
                      x="25"
                      y="450"
                      width="864"
                      height="353"
                      style={{maskType: 'luminance'}}
                    >
                      <mask
                        id="mask7_3491_244"
                        maskUnits="userSpaceOnUse"
                        x="25"
                        y="450"
                        width="864"
                        height="353"
                        style={{maskType: 'luminance'}}
                      >
                        <path
                          d="M888.114 618.73L62.8264 802.834L25.2664 634.426L850.53 450.322L888.114 618.73Z"
                          fill="white"
                        ></path>
                      </mask>
                      <g mask="url(#mask7_3491_244)">
                        <path
                          d="M961.386 947.17L136.098 1131.27L-48.0056 306.01L777.282 121.906L961.386 947.17Z"
                          fill="white"
                        ></path>
                      </g>
                    </mask>
                    <g mask="url(#mask6_3491_244)">
                      <g opacity="0.8">
                        <path
                          d="M961.379 947.178L136.096 1131.28L-48.0082 305.999L777.275 121.895L961.379 947.178Z"
                          fill="#0095DF"
                        ></path>
                      </g>
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_3491_244">
                      <rect width="842.2" height="595.5" fill="white" transform="translate(0.498291 0.0819092)"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              
              <div style={{
                position: 'absolute',
                left: '80px',
                top: 'calc(50% + -1.1px + 11px)',
                zIndex: 2,
                height: '2.2px',
                width: '160px',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                paddingLeft: '160px',
                paddingTop: '2.2px'
              }}></div>
              
              <div style={{
                position: 'absolute',
                left: '-95.82px',
                top: '-277.71px',
                zIndex: 3,
                display: 'flex',
                height: '96px',
                width: '224px',
                alignItems: 'flex-start',
                paddingLeft: '224px',
                paddingTop: '96px'
              }}>
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}></div>
              </div>
              
              <div style={{
                zIndex: 4,
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: '11px',
                paddingLeft: '13px'
              }}>
                <div style={{
                  display: 'flex',
                  width: '529px',
                  alignItems: 'center'
                }}>
                  <div style={{
                    flexGrow: 1,
                    fontSize: '18px',
                    fontWeight: 'bold',
                    lineHeight: 1,
                    color: '#1f2937'
                  }}>
                    Міжнародна фахова школа "Медицина сну"
                  </div>
                </div>
                
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  alignSelf: 'stretch',
                  fontSize: '12px'
                }}>
                  <div style={{
                    marginBottom: '76px',
                    display: 'flex',
                    width: '128px',
                    flexDirection: 'column',
                    gap: '7.3px',
                    lineHeight: 1,
                    color: '#1f2937'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      maxWidth: '124px'
                    }}>
                      <div style={{
                        flexGrow: 1,
                        fontWeight: 'bold'
                      }}>
                        КИЇВ, 10.07.2025
                      </div>
                    </div>
                    <div style={{
                      fontFamily: 'Open Sans',
                      fontWeight: '300'
                    }}>
                      Кількість годин - 40
                    </div>
                  </div>
                  
                  <div style={{
                    position: 'relative',
                    display: 'flex',
                    flexGrow: 1,
                    alignSelf: 'stretch',
                    paddingBottom: '34px',
                    paddingRight: '224px'
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      overflow: 'clip'
                    }}>
                      <div style={{
                        height: '160px',
                        maxHeight: '100%',
                        width: '160px',
                        maxWidth: '100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '-0.01px -0.02px',
                        backgroundSize: '100% 100%'
                      }}></div>
                    </div>
                    
                    <div style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 'calc(50% + -41.65px + -6.37px)',
                      zIndex: 2,
                      display: 'flex',
                      height: '80px',
                      width: '112px',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        overflow: 'clip'
                      }}>
                        <div style={{
                          height: '80px',
                          maxHeight: '100%',
                          width: '112px',
                          maxWidth: '100%',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: '0px 0px',
                          backgroundSize: '100% 100%'
                        }}></div>
                      </div>
                    </div>
                    
                    <div style={{
                      position: 'absolute',
                      right: 0,
                      top: 'calc(50% + -31.68px + -22.37px)',
                      display: 'flex',
                      height: '64px',
                      width: '208px',
                      flexDirection: 'column',
                      gap: '6.3px',
                      maxWidth: '206px'
                    }}>
                      <div style={{
                        width: '144px',
                        fontWeight: 'bold',
                        lineHeight: 1,
                        color: '#1f2937'
                      }}>
                        ДАРІЯ КОСТЮКОВА
                      </div>
                      <div style={{
                        lineHeight: '17px',
                        color: 'lightslategray'
                      }}>
                        <span>
                          <p>Президентка Європейської</p>
                          <p>асоціації медицини сну та</p>
                          <p>нейрофізіології (ESMANA)</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div style={{
                position: 'absolute',
                left: 'calc(50% + -8px + -140.36px)',
                top: '-171.71px',
                zIndex: 5,
                display: 'flex',
                height: '16px',
                width: '320px',
                alignItems: 'flex-start',
                paddingLeft: '320px',
                paddingTop: '16px'
              }}>
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  fontWeight: '500',
                  lineHeight: 1,
                  color: '#0ea5e9'
                }}>
                  С Е Р Т И Ф І К А Т / C E R T I F I C A T E
                </div>
              </div>
              
              <div style={{
                position: 'absolute',
                left: 'calc(50% + -16px + -165.89px)',
                top: '-93.75px',
                zIndex: 6,
                display: 'flex',
                height: '32px',
                width: '417px',
                alignItems: 'flex-start',
                paddingLeft: '417px',
                paddingTop: '32px'
              }}>
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  fontSize: '32px',
                  fontWeight: '500',
                  lineHeight: 1,
                  color: '#0ea5e9'
                }}>
                  П І П У Ч А С Н И К А
                </div>
              </div>
              
              <div style={{
                position: 'absolute',
                left: '160px',
                right: '160px',
                top: '-20.11px',
                zIndex: 7,
                height: '12px',
                maxWidth: '285px'
              }}>
                <div style={{
                  fontSize: '12px',
                  lineHeight: 1,
                  color: 'lightslategray'
                }}>
                  Сертифікат підтверджує участь у заході:
                </div>
              </div>
              
              <div style={{
                position: 'absolute',
                left: '256px',
                right: '256px',
                top: '-148.21px',
                zIndex: 8,
                height: '12px',
                maxWidth: '85px'
              }}>
                <div style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  lineHeight: 1,
                  color: '#0ea5e9'
                }}>
                  № 2025/000
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
)

export default AnotherExampleCertificate
